$(document).ready(function() {
  var head_he = $('.head_stitckey').outerHeight()
  var head_wid = $('.main-container').width()

  $('.middle-content').css({ 'margin-top': head_he + 'px' })
  $('.head_stitckey').css({ width: head_wid + 'px' })

  $('.swap_1').click(function() {
    $('#swap_1').hide()
    $('#swap_2').show()
  })
  $('.swap_2').click(function() {
    $('#swap_1').show()
    $('#swap_2').hide()
  })
})
